import { Shield, TrendingUp, Landmark, Wallet } from "lucide-react";

const arguments_data = [
  {
    num: "01",
    title: "Kaufkraft erhalten & Inflation schlagen",
    icon: TrendingUp,
    text: "Der Euro hat seit 2000 rund 45 % seiner Kaufkraft verloren. Gold legte im selben Zeitraum +1.400 % zu — von 262 €/oz auf heute ca. 4.000 €/oz. Wer spart, verliert. Wer in Edelmetalle investiert, erhält reale Werte über Generationen.",
    highlight: "+1.400 %",
  },
  {
    num: "02",
    title: "Bankenunabhängig & vor staatlichem Zugriff geschützt",
    icon: Shield,
    text: "Ihr Edelmetall wird auf Ihren Namen & Ihre Rechnung im Schweizer Zollfreilager gelagert — außerhalb der EU, außerhalb des Bankensystems. Kein Gegenparteirisiko. Kein Bail-in. Kein staatlicher Zugriff. Insolvenzschutz.",
    highlight: "Schweizer Zollfreilager",
  },
  {
    num: "03",
    title: "Steuerfrei kaufen & Gewinne steuerfrei vereinnahmen",
    icon: Landmark,
    text: "Physische Edelmetalle im Zollfreilager: 0 % Mehrwertsteuer beim Kauf. Kursgewinne nach 12 Monaten: 0 % Abgeltungssteuer (§ 23 EStG). Kein anderes liquides Anlageinstrument bietet diesen legalen Steuervorteil — auch für Silber, Platin & Palladium.",
    highlight: "0 % Steuer",
  },
  {
    num: "04",
    title: "Liquider Wertspeicher — jederzeit verfügbar",
    icon: Wallet,
    text: "Ihr Edelmetall-Depot ist kein gebundenes Kapital. Wertstand jederzeit einsehbar. Verkauf oder physische Auslieferung jederzeit möglich. Standardformate (1 oz – 1 kg) sichern sofortige Marktgängigkeit.",
    highlight: "Jederzeit verfügbar",
  },
];

export default function ArgumentsSection() {
  return (
    <section
      id="argumente"
      data-testid="arguments-section"
      className="py-24 sm:py-32 bg-[#0C1620] relative"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <p className="uppercase text-xs tracking-[0.25em] text-[#C5993A] mb-4">
            Warum Edelmetalle
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-white">
            4 unschlagbare Argumente
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {arguments_data.map((arg, i) => {
            const Icon = arg.icon;
            return (
              <div
                key={arg.num}
                data-testid={`argument-card-${arg.num}`}
                className="group relative bg-[#12202f] border border-[#3A4F60]/50 rounded-lg p-8 lg:p-10 hover:-translate-y-1 hover:border-[#C5993A]/50 transition-all duration-300"
              >
                {/* Large background number */}
                <span className="absolute top-4 right-6 font-heading text-[120px] leading-none text-[#3A4F60]/10 font-bold select-none pointer-events-none group-hover:text-[#C5993A]/10 transition-colors duration-500">
                  {arg.num}
                </span>

                <div className="relative z-10">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 rounded-lg bg-[#C5993A]/10 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-[#C5993A]" />
                    </div>
                    <span className="font-heading text-lg text-[#C5993A] font-semibold">
                      {arg.highlight}
                    </span>
                  </div>

                  <h3 className="font-heading text-xl sm:text-2xl font-medium text-white mb-4">
                    {arg.title}
                  </h3>

                  <p className="text-[#8899AA] leading-relaxed text-sm sm:text-base font-light">
                    {arg.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
